exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button__Button--ajevi{\r\n    display: inline-block;\r\n    padding: 10px 20px;\r\n    border-radius: 4px;\r\n    border:1px solid #ccc;\r\n    color:black;\r\n    margin-right: 15px;\r\n    text-transform: uppercase;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n}\r\n\r\n.Button__Button--ajevi:focus{\r\n    outline:none;\r\n}\r\n\r\n.Button__Button--ajevi:active{\r\n    box-shadow: inset 2px 2px 1px rgba(0,0,0, .3)\r\n}\r\n\r\n.Button__Button--ajevi:disabled{\r\n    background: #ccc;\r\n    color:black;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.Button__error--3i2F2{\r\n    background:rgba(255,0,0, 1)\r\n}\r\n\r\n.Button__success--1wqIA{\r\n    background:rgba(0,255,0, 1)\r\n}\r\n\r\n.Button__primary--2Limk{\r\n    background: #2284f6;\r\n    color:#fff;\r\n}", ""]);

// exports
exports.locals = {
	"Button": "Button__Button--ajevi",
	"error": "Button__error--3i2F2",
	"success": "Button__success--1wqIA",
	"primary": "Button__primary--2Limk"
};